import * as actions from './actions'

const practitionerTitlesModule = {
    namespaced: true,
    actions,
}

export default practitionerTitlesModule
